import React from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {loadParameter} from "../../../redux_slices/contextSlice";

const TermsAndConditionsContent = () => {
    const {t} = useTranslation();
    const customTermsAndConditionsHTML = useSelector(state => loadParameter(state, "customTermsAndConditions"));

    return (
        <div>
            {customTermsAndConditionsHTML ? (
                <div className="content" dangerouslySetInnerHTML={{__html: customTermsAndConditionsHTML}}></div>
            ) : (
                <div>
                    <p>
                        {t("TERMSCONDITIONS.WE_NEED")}{" "}
                        <a href="https://omnios.ai/terms-and-conditions/" target="_blank" rel="noopener noreferrer">
                            {t("TERMSCONDITIONS.TERMS")}
                        </a>{" "}
                        {t("TERMSCONDITIONS.AND")}{" "}
                        <a href="https://omnios.ai/privacy-policy/" target="_blank" rel="noopener noreferrer">
                            {t("TERMSCONDITIONS.POLICY")}
                        </a>{" "}
                        {t("TERMSCONDITIONS.TO_USE")}
                    </p>
                </div>
            )}
        </div>
    );
};
export default TermsAndConditionsContent;
